export type QueryValue = string | number | boolean | null | undefined | QueryValue[];

export const buildQuery = (paramsObj: Record<string, QueryValue> = {}): string => {
  const params = new URLSearchParams();

  Object.entries(paramsObj).forEach(([key, value]) => {
    if (value === undefined || value === null) return;

    if (Array.isArray(value)) {
      value.forEach((v) => {
        if (v !== undefined && v !== null) {
          params.append(key, String(v));
        }
      });
      return;
    }

    params.append(key, String(value));
  });

  return params.toString();
};

export const buildUrl = (baseUrl: string, paramsObj: Record<string, QueryValue> = {}): string => {
  const query = buildQuery(paramsObj);
  return query ? `${baseUrl}?${query}` : baseUrl;
};
